// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"7ce08fd6","144":"51e9e9c0","291":"622ff509","365":"2e43cc46","622":"46ac5cce","632":"3166eb24","783":"66deb820"}[chunkId] + ".chunk.css";
};